import { useEffect, useState } from "react";

// Below Tailwind's `lg` (overridden to 1025px), where the sidebar is off-canvas.
const QUERY = "(max-width: 1024px)";

const useIsBelowLg = () => {
    const [isBelowLg, setIsBelowLg] = useState(
        () => window.matchMedia?.(QUERY)?.matches ?? false
    );

    useEffect(() => {
        const mql = window.matchMedia?.(QUERY);
        if (!mql) return;
        const onChange = (e: MediaQueryListEvent) => setIsBelowLg(e.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, []);

    return isBelowLg;
};

export default useIsBelowLg;
